import script from "./EventItemList.vue?vue&type=script&setup=true&lang=js"
export * from "./EventItemList.vue?vue&type=script&setup=true&lang=js"

import "./EventItemList.vue?vue&type=style&index=0&id=1cab84eb&scoped=true&lang=css"

import exportComponent from "/home/jenkins/storybird-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cab84eb"]])

export default __exports__